import * as types from '../types/companies'
import company from 'api/company'
import moment from 'moment'

const { companies: companiesApi } = company

export const updateExistingCompanyAct = (company) => ({
  type: types.UPDATE_EXISTING_COMPANY,
  company,
})
export const setAllCompaniesAct = (companies) => ({ type: types.SET_ALL_COMPANIES, companies })
export const addNewCompanyAct = (company) => ({ type: types.ADD_NEW_COMPANY, company })
export const deleteCompanyAct = (company) => ({ type: types.DELETE_COMPANY, company })

export const getCompanies = (company) => (dispatch) => {
  return new Promise((resolve, reject) => {
    companiesApi.get(company).then(({ data, status }) => {
      if (status === 200) {
        dispatch(setAllCompaniesAct(data.results))
        return resolve(data)
      }
      return reject(data)
    })
  })
}

export const addNewCompany = (company) => (dispatch) => {
  return new Promise((resolve, reject) => {
    companiesApi.add(company).then(({ data }) => {
      if (data.body.ok) {
        const newCompany = data.body.company
        dispatch(addNewCompanyAct(newCompany))
        return resolve(data.body)
      }
      return reject(data.body)
    })
  })
}

export const updateCompany = (company) => async (dispatch) => {
  try {
    const { data } = await companiesApi.update(company)

    dispatch(updateExistingCompanyAct(data.company))

    return data.company
  } catch ({ response = {}, message }) {
    const { data } = response

    throw data || message
  }
}

export const deleteCompany = (downloadData) => async (dispatch, oldState) => {
  const company = oldState().companies

  try {
    const { data, headers } = await companiesApi.deleteCompany(company, downloadData)

    if (downloadData) {
      const url = window.URL.createObjectURL(new Blob([data], { type: headers['content-type'] }))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', `${company.name}_${company.nif}_${moment().format('DD-MM-YYYY')}.zip`)

      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    }

    return true
  } catch ({ response = {}, message }) {
    throw new Error('delete_company_error')
  }
}
